import { useTranslation } from "react-i18next";

import { LinkSentContent } from "../components/LinkSentContent";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/v2/card";

function LinkSentPage() {
  const { t } = useTranslation();

  return (
    <Card className="w-full max-w-lg mx-auto shadow-lg">
      <CardHeader className="space-y-2 pb-4">
        <CardTitle>{t("auth.pages.linkSent.header")}</CardTitle>
        <CardDescription>
          {t("auth.pages.linkSent.subHeader")}
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <LinkSentContent />
      </CardContent>
    </Card>
  );
}

export default LinkSentPage;
